"use client";

import { useState } from "react";
import { Play, ArrowRight, Check, CircleAlert, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KhoiDauKyNguyenGiaoThuongSo() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const [prompt, setPrompt] = useState("");
  const [error, setError] = useState("");
  const stats = [{
    icon: Check,
    value: "100% AI",
    label: "WordPress Power"
  }, {
    icon: Check,
    value: "Secure",
    label: "Managed Hosting"
  }, {
    icon: Check,
    value: "24/7",
    label: "Expert Support"
  }];
  const valuePoints = [{
    text: "WordPress backend"
  }, {
    text: "Hosting, SSL & domain"
  }, {
    text: "Zero coding required"
  }];
  const handleGenerate = () => {
    if (prompt.length < 10) {
      setError("Please describe your vision in at least 10 characters.");
      return;
    }
    window.location.href = `/PricingPage?prompt=${encodeURIComponent(prompt)}`;
  };
  return <section data-section-id="232192" id="your-vision-prompted-to-life" className="bg-background relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <svg className="absolute inset-0 w-full h-full opacity-[0.04]" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="var(--foreground)" strokeWidth="1" />
            </pattern>
            <pattern id="dots" width="60" height="60" patternUnits="userSpaceOnUse">
              <circle cx="30" cy="30" r="1.5" fill="var(--foreground)" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>

        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-lg opacity-10 blur-3xl" style={{
        background: "var(--primary)"
      }} />
        <div className="absolute bottom-1/4 right-1/3 w-72 h-72 rounded-lg opacity-8 blur-3xl" style={{
        background: "var(--chart-4)"
      }} />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-4 md:px-10 py-16 md:py-24">
        <div className="flex flex-col items-center">

          <div ref={leftRef} className={`w-full flex flex-col gap-6 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 self-start px-3 py-1.5 rounded-lg border" style={{
            borderColor: "var(--border)",
            background: "var(--accent)",
            color: "var(--foreground)"
          }}>
              <span className="w-2 h-2 rounded-lg animate-pulse" style={{
              background: "var(--primary)"
            }} />
              <span className="text-xs font-default font-semibold tracking-wider uppercase">AI-Powered WordPress Builder</span>
            </div>

            <div>
              <h1 className="font-default text-4xl sm:text-5xl md:text-6xl xl:text-7xl font-bold leading-tight tracking-tighter" style={{
              color: "#1F1F1F"
            }}>
                Build Your Website From a Prompt.
              </h1>
            </div>

            <p className="font-default text-lg md:text-xl leading-relaxed max-w-xl" style={{
            color: "#6B7280"
          }}>
              Describe your business, project, store, blog or organization and Webshingle will help turn it into a customizable WordPress website.
            </p>

            <div className="flex flex-wrap gap-4 items-center">
              <Button asChild size="lg" className="font-default font-bold text-base px-8 py-3 h-auto rounded-lg transition-all duration-200 hover:scale-105 hover:shadow-lg shadow-md" style={{
              background: "#A8D72E",
              color: "#1F1F1F"
            }}>
                <Link to="/PricingPage">
                  Build My Site
                  <ArrowRight className="ml-1 size-4" />
                </Link>
              </Button>

              <Button variant="outline" size="lg" className="font-default font-bold text-base px-8 py-3 h-auto rounded-lg flex items-center gap-2 transition-all duration-200 hover:scale-105" style={{
              borderColor: "var(--border)",
              color: "var(--chart-2)"
            }}>
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg" style={{
                background: "var(--chart-2)",
                color: "var(--primary)"
              }}>
                  <Play className="size-3.5 fill-current" />
                </span>
                Watch Demo
              </Button>
            </div>

            <div className="flex flex-wrap gap-6 mt-2">
              {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-green-50" style={{
                color: "#A8D72E"
              }}>
                    <stat.icon className="size-4" />
                  </div>
                  <div>
                    <p className="font-default text-sm font-bold leading-tight" style={{
                  color: "#1F1F1F"
                }}>
                      {stat.value}
                    </p>
                    <p className="font-default text-xs" style={{
                  color: "#6B7280"
                }}>
                      {stat.label}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12 md:mt-16 w-full rounded-lg overflow-hidden shadow-xl border border-white/10" style={{
            background: "#1F1F1F"
          }}>
              <div className="p-8 md:p-12">
                <div className="flex flex-col gap-6">
                  <div className="space-y-2">
                    <span className="text-[#A8D72E] font-mono text-sm font-bold uppercase tracking-widest">Start with a prompt</span>
                    <h2 className="text-white text-2xl md:text-3xl font-bold font-default">Tell Webshingle what you want to build</h2>
                  </div>

                  <div className="relative">
                    <textarea value={prompt} onChange={e => {
                    setPrompt(e.target.value);
                    if (e.target.value.length >= 10) setError("");
                  }} placeholder="Describe your business, pages, services, products, audience, and style..." className="w-full min-h-[200px] p-6 rounded-lg border bg-white/5 text-white font-default text-lg outline-none focus:ring-2 focus:ring-[#A8D72E]/50 transition-all resize-none" style={{
                    borderColor: error ? "#ef4444" : "rgba(255,255,255,0.1)"
                  }} />
                    
                    <div className="mt-3 min-h-[24px]">
                      {error && <p className="flex items-center gap-1.5 text-sm font-medium text-red-400 animate-in fade-in slide-in-from-top-1">
                          <CircleAlert className="size-4" />
                          {error}
                        </p>}
                      {!error && prompt.length > 2000 && <p className="flex items-center gap-1.5 text-sm font-medium text-amber-400 animate-in fade-in slide-in-from-top-1">
                          <Info className="size-4" />
                          Prompt is very long. Consider being more concise.
                        </p>}
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row items-center gap-8">
                    <Button onClick={handleGenerate} size="lg" className="w-full md:w-auto font-default font-bold rounded-lg h-14 px-10 text-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]" style={{
                    background: "#A8D72E",
                    color: "#1F1F1F"
                  }}>
                      Generate My Website
                      <ArrowRight className="ml-2 size-5" />
                    </Button>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full md:w-auto">
                      {valuePoints.map((point, i) => <div data-index={i} key={i} className="flex items-center gap-3 text-sm font-medium text-gray-400">
                          <div className="flex-shrink-0 w-5 h-5 rounded-lg bg-[#A8D72E]/10 flex items-center justify-center">
                            <Check className="size-3 text-[#A8D72E]" />
                          </div>
                          {point.text}
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}